import { useMemo } from 'react';
import { contextKindsQuery } from '@gonfalon/rest-api/queries/contexts';
import { useQuery } from '@tanstack/react-query';

import type { ContextKind } from '../types/types';

// In some cases, useContextKinds is used dependently on a user input, and not the project loader.
// This would be easier if it useProjectKey could be provided via a context without loader
export const useContextKinds = (projectKey: string) => {
  const { data, isLoading } = useQuery({ ...contextKindsQuery({ projectKey }), enabled: !!projectKey });
  const contextKinds = useMemo(() => (data?.items ?? []).map<ContextKind>((c) => c), [data?.items]);
  const unhiddenContextKinds = useMemo(() => contextKinds.filter((c) => !c.archived), [contextKinds]);

  return {
    contextKinds,
    unhiddenContextKinds,
    isReady: !isLoading,
  };
};
